import React from "react"
import { FormProvider, type UseFormReturn } from "react-hook-form"

const FormForm = <TFieldValues extends Record<string, any>>(
  props: React.DetailedHTMLProps<React.FormHTMLAttributes<HTMLFormElement>, HTMLFormElement> & {
    formMethods: UseFormReturn<TFieldValues>
    disabled?: boolean
  }
) => {
  const { formMethods, disabled, ...formProps } = props

  if (disabled) {
    return (
      <form {...formProps}>
        <fieldset disabled className="m-0 border-0 p-0">
          <FormProvider {...formMethods}>{props.children}</FormProvider>
        </fieldset>
      </form>
    )
  }

  return (
    <form {...formProps}>
      <FormProvider {...formMethods}>{props.children}</FormProvider>
    </form>
  )
}

export default FormForm
